import TranslationProvider from '@/provider/translations.js'

export const canDelegateREA = (compiledPoll, modalBulkActionsPayload) => {
  if (!modalBulkActionsPayload['rea']){
    return null;
  }
  if (
    modalBulkActionsPayload['rea'] &&
    (
      compiledPoll['attributes']['gec.involved_subject.rating_evaluation_approver'] === modalBulkActionsPayload['rea'].reference ||
      compiledPoll['attributes']['gec.involved_subject.rating_evaluator'] === modalBulkActionsPayload['rea'].reference
    )
  ) {
    return 'app.massive_error_delegate_rea.already_rea'
  }

  if (!compiledPoll.attributes['gec.involved_subject.rating_evaluation_approver']) {
    return TranslationProvider.getTrans('app.massive_error_delegate_rea')
  }

  if (!compiledPoll['enabledActions']['editDelegatedREA']) {
    return TranslationProvider.getTrans('app.massive_error_delegate_rea')
  }

  if (!compiledPoll['enabledActions']['settings']) {
    return TranslationProvider.getTrans('app.massive_error_delegate_rea')
  }

  return null
}

export const canDelegateRE = (compiledPoll, modalBulkActionsPayload) => {
  if (!modalBulkActionsPayload['re']){
    return null;
  }
  if (
    modalBulkActionsPayload['re'] &&
    (
      compiledPoll['attributes']['gec.involved_subject.rating_evaluator'] === modalBulkActionsPayload['re'].reference ||
      compiledPoll['attributes']['gec.involved_subject.rating_evaluation_approver'] === modalBulkActionsPayload['re'].reference
    )
  ) {
    return TranslationProvider.getTrans('app.massive_error_delegate_re.already_re')
  }

  if (!compiledPoll.attributes['gec.involved_subject.rating_evaluator']) {
    return TranslationProvider.getTrans('app.massive_error_delegate_re')
  }

  if (!compiledPoll['enabledActions']['editDelegatedRE']) {
    return TranslationProvider.getTrans('app.massive_error_delegate_re')
  }

  if (!compiledPoll['enabledActions']['settings']) {
    return TranslationProvider.getTrans('app.massive_error_delegate_re')
  }

  return null
}
